import { http } from 'vue'

export default {
  // load clients from the API server
  loadClients (context, params = {}) {
    const withParam = ((params.with) ? '&with=' + params.with : '')
    const pageParam = '&page=' + ((params.page) ? params.page : 1)
    const perPageParam = '&per_page=' + ((params.perPage) ? params.perPage : 50)
    const typeParam = ((params.type) ? '&type=' + params.type : '')
    const searchParam = ((params.search) ? '&search=' + params.search : '')
    const periodParam = ((params.period) ? '&period=' + params.period : '')
    const statusParam = ((params.status) ? '&status=' + params.status : '')
    const statusOrigin = ((params.origin) ? '&origin=' + params.origin : '')
    const statusOpened = ((params.opened) ? '&opened=' + params.opened : '')
    const sortParam = ((params.sort) ? '&sort=' + params.sort : '')
    return http.get('clients?company_id=' + params.companyId + pageParam + perPageParam + typeParam + searchParam + periodParam + statusParam + withParam + sortParam + statusOrigin + statusOpened)
  },
  // create client at the API server
  postCheckClient (context, params = {}) {
    return http.post('clients/check', params.data)
  },
  // create client at the API server
  postClient (context, params = {}) {
    return http.post('clients', params.data)
  },
  // edit client at the API server
  putClient (context, params = {}) {
    return http.put('clients/' + params.clientId, params.data)
  },
  // edit client at the API server
  putClientImages (context, params = {}) {
    return http.put('clients/images/' + params.clientId, params.data)
  },
  // save message for client at the API server
  getMessages (context, params = {}) {
    return http.get('clients/messages/' + params.clientId, params.data)
  },
  // save message for client at the API server
  putMessage (context, params = {}) {
    return http.put('clients/message/' + params.clientId, params.data)
  },
  // load client details from the API server
  loadClientDetails (context, params = {}) {
    return http.get('clients/' + params.clientId + '?company_id=' + params.companyId)
  },
  // delete client files at the API server
  deleteClientFile (context, params = {}) {
    return http.delete('clients/' + params.id + '?company_id=' + params.companyId + '&file=' + params.file + '&dynamic=' + params.dynamic)
  },
  setClient (context, payload) {
    context.commit('SET_CLIENT', payload)
  },
  loadPoints (context, params = {}) {
    return http.get('clients/points/' + params.clientId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/actions.js